<template>
  <router-view />
  <AppSnackbar />
</template>

<script>
import AppSnackbar from '@/components/AppSnackbar.vue';

export default {
  name: 'App',

  components: {
    AppSnackbar
  }
};
</script>

<style>
html {
  overflow-y: auto !important;
}

html,
body,
#app {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
}
</style>
